
import { useState } from "react";
import { migrateImmobilier } from "./ Migrateimmobilier";

const MigratePage = () => {
  const [done, setDone] = useState(false);
  const [loading, setLoading] = useState(false);

  const handleMigrate = async () => {
    setLoading(true);
    await migrateImmobilier();
    setLoading(false);
    setDone(true);
  };

  return (
    <div style={{ padding: "40px", textAlign: "center" }}>
      <h2>🔧 Migration Firebase</h2>
      <p>Ajoute les champs manquants à tous les documents de la collection <strong>immobilier</strong>.</p>

      <button
        onClick={handleMigrate}
        disabled={loading || done}
        style={{
          padding: "14px 32px", fontSize: "16px",
          background: done ? "#16a34a" : "#2563eb",
          color: "#fff", border: "none",
          borderRadius: "10px", cursor: "pointer",
        }}
      >
        {loading ? "⏳ Migration en cours..." : done ? "✅ Migration terminée !" : "🚀 Lancer la migration"}
      </button>

      {done && (
        <p style={{ marginTop: "20px", color: "#16a34a" }}>
          ✅ Vérifie ta console et Firebase pour confirmer.
        </p>
      )}
    </div>
  );
};

export default MigratePage;